<template>
  <div class="pie-chart">
    <doughnut :data="series"
              :options="options" />
  </div>
</template>

<script>
  import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
  import { Doughnut } from 'vue-chartjs';

  ChartJS.register(ArcElement, Tooltip);

  export default {
    name: 'PieChart',
    components: {
      Doughnut,
    },
    props: {
      series: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
.pie-chart {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
</style>
